import { render, staticRenderFns } from "./CreateWorkOrderView.vue?vue&type=template&id=b646fab0&scoped=true&"
import script from "./CreateWorkOrderView.vue?vue&type=script&lang=ts&"
export * from "./CreateWorkOrderView.vue?vue&type=script&lang=ts&"
import style0 from "./CreateWorkOrderView.vue?vue&type=style&index=0&id=b646fab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b646fab0",
  null
  
)

export default component.exports